import { type VariantProps, cva } from 'class-variance-authority'

export const avatarVariant = cva(
	'text-foreground bg-secondary inline-flex shrink-0 select-none items-center justify-center overflow-hidden font-normal',
	{
		variants: {
			size: {
				sm: 'size-10 text-xs',
				base: 'size-16 text-2xl',
				lg: 'size-32 text-5xl',
			},
			shape: {
				circle: 'rounded-full',
				square: 'rounded-md',
			},
		},
	},
)

export type AvatarVariants = VariantProps<typeof avatarVariant>
